import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import PasswordInput from "@/components/PasswordInput";
import { useAcenteAuth } from "@/context/AcenteAuthContext";

export default function AcenteRegister() {
  const nav = useNavigate();
  const { register } = useAcenteAuth();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    agency_name: "",
    phone: "",
  });
  const [busy, setBusy] = useState(false);

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Şifre en az 6 karakter olmalı");
      return;
    }
    setBusy(true);
    try {
      await register({ ...form, email: form.email.trim().toLowerCase() });
      toast.success("Hesabınız oluşturuldu");
      nav("/acente");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = Array.isArray(detail)
        ? detail.map((d) => d.msg).join(" · ")
        : typeof detail === "string"
        ? detail
        : "Kayıt yapılamadı";
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-canvas-cream flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md bg-white rounded-3xl border border-brand-navy/10 shadow-xl p-8" data-testid="acente-register-card">
        <div className="text-xs uppercase tracking-[0.3em] text-brand-orange font-semibold mb-2">Ariaf ASIS Acente Paneli</div>
        <h1 className="font-serif text-3xl text-brand-navy">Acente Kaydı</h1>
        <p className="text-sm text-slate-600 mt-1">Acentenizi kaydedin, hemen rezervasyon oluşturmaya başlayın.</p>

        <form onSubmit={submit} className="mt-6 grid gap-4" data-testid="acente-register-form">
          <div>
            <Label>Yetkili Ad Soyad</Label>
            <Input value={form.name} onChange={onChange("name")} required minLength={2} data-testid="acente-register-name" />
          </div>
          <div>
            <Label>Acente / Firma Adı</Label>
            <Input value={form.agency_name} onChange={onChange("agency_name")} required minLength={2} data-testid="acente-register-agency" />
          </div>
          <div>
            <Label>Telefon</Label>
            <Input value={form.phone} onChange={onChange("phone")} data-testid="acente-register-phone" />
          </div>
          <div>
            <Label>E-posta</Label>
            <Input value={form.email} onChange={onChange("email")} type="email" required data-testid="acente-register-email" />
          </div>
          <div>
            <Label>Şifre (en az 6 karakter)</Label>
            <PasswordInput value={form.password} onChange={onChange("password")} required minLength={6} data-testid="acente-register-password" />
          </div>
          <Button type="submit" disabled={busy} className="bg-brand-orange text-white hover:bg-brand-orange-dark" data-testid="acente-register-submit">
            {busy ? "Kaydediliyor..." : "Kayıt ol ve giriş yap"}
          </Button>
        </form>

        <div className="mt-6 text-sm text-slate-600 text-center">
          Zaten hesabınız var mı?{" "}
          <Link to="/acente/giris" className="text-brand-orange hover:underline font-medium" data-testid="acente-register-login-link">
            Giriş yapın
          </Link>
        </div>
      </div>
    </div>
  );
}
